<template>
  <v-card class="mx-auto" tile :loading="laden">
    <v-system-bar color="indigo darken-2" dark>
      <v-spacer></v-spacer>
      <span></span>
    </v-system-bar>

    <v-toolbar color="indigo" dark>
      <v-toolbar-title>Introductie</v-toolbar-title>

      <v-spacer></v-spacer>

      <v-btn icon @click="next">
        <v-icon>mdi-arrow-right</v-icon>
      </v-btn>
    </v-toolbar>
    <v-layout>
      <div>
        <br />
        <p style="margin-left: 10px;">
          Beste Lisanne,<br />
          <br />
          Om milieubewust 2021 in te gaan,<br />
          proberen ook wij onze slag te slaan.<br />
          Dat doen we bijvoorbeeld op deze manier,<br />
          nu gebruiken we minder papier!<br />
          <br />
          We proberen bij elk woord dat je gebruikt,<br />
          ervoor te zorgen dat een nieuw gedeelte opduikt.<br />
          Als dit dan niet werkt,<br />
          druk dan op het pijltje hierboven, zodat het wel wordt opgemerkt.<br />
        </p>
      </div>
    </v-layout>
  </v-card>
</template>

<script>
export default {
  data: () => ({
    time: "",
    laden: false,
  }),
  methods: {
    next() {
      this.$router.push({ name: "Deel1" });
    },
  },
  computed: {},
  mounted() {
    let SpeechRecognition =
      window.SpeechRecognition || window.webkitSpeechRecognition;
    let recognition = SpeechRecognition ? new SpeechRecognition() : false;

    recognition.lang = "nl";
    recognition.interimResults = true;

    recognition.addEventListener("result", (event) => {
      const text = Array.from(event.results)
        .map((result) => result[0])
        .map((result) => result.transcript)
        .join("");
      this.time = text.split(" ").pop();
      if (text.includes("gemerkt")) {
        this.laden = true;
        this.$router.push({ name: "Deel1" });
      }
    });

    recognition.addEventListener("end", () => {
      if (this.$route.name == "Begin") {
        recognition.start();
      }
    });
    recognition.start();
  },
};
</script>
